import React, { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { protectedRoutes } from 'constants/routes'

import { useAuthContext } from 'AuthProvider'
import { LicenseManager } from 'ag-grid-enterprise'
import { AuthAction, Login, PasswordRest } from 'pages'
import { useApiCacheStore, isPageReload, markAsNavigated, useRefreshHandler } from 'store/apiCacheStore'
import { AfterLogin } from 'templates'

function App() {
  LicenseManager.setLicenseKey(process.env.REACT_APP_AGGRID_LICENSEKEY as string)

  const { user, loginUserInfoResult } = useAuthContext()
  const { setIsPageReload } = useApiCacheStore()
  
  // Setup cache navigation detection and refresh handler
  useRefreshHandler()
  
  useEffect(() => {
    // Detect page reload on app start
    const pageReloadDetected = isPageReload()
    setIsPageReload(pageReloadDetected)
    
    if (!pageReloadDetected) {
      markAsNavigated()
    }
    
    // Reset reload flag after detection
    const timer = setTimeout(() => {
      setIsPageReload(false)
    }, 1000)
    
    return () => clearTimeout(timer)
  }, [setIsPageReload])

  return (
    <BrowserRouter>
      <Routes>
        <Route path={protectedRoutes.Login.path} element={<Login />} />
        <Route path={protectedRoutes.PasswordRest.path} element={<PasswordRest />} />
        <Route path={protectedRoutes.AuthAction.path} element={<AuthAction />} />
        <Route
          path={`${protectedRoutes.Top.path}*`}
          element={
            loginUserInfoResult?.status === 'success' ? (
              <AfterLogin />
            ) : (
              <Navigate
                to={`/${protectedRoutes.Login.path}${user?.tenantId ? `?tenantId=${user?.tenantId}` : ''}`}
                replace
              />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
